import { IconButton } from '@mui/material';
import React from 'react';
import SyncProblemOutlined from '@mui/icons-material/SyncProblemOutlined';
import { Tooltip } from 'framework/ui/mui-builder';
import { ModalForm, TextArea } from 'framework/form';
import useRiskService from '../useRiskService';
import { useParams } from 'react-router-dom';
import { Modal } from 'framework/ui/ui-builder';
import { ProjectRisksResponse, RisksType, UseRiskByIdResult } from 'domain/shared/newProject';
import { useShowContext } from 'framework/show';

type EscalationButtonProps = {
  isEscalated: boolean;
  onEscalationUpdated?: UseRiskByIdResult['refetch'];
};
const EscalationButton = ({ isEscalated, onEscalationUpdated }: EscalationButtonProps) => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const { escalateRisk, deescalateRisk } = useRiskService();
  const { riskId } = useParams();
  const { setData } = useShowContext<RisksType>();
  return (
    <>
      <Tooltip title={!isEscalated ? 'Escalate risk' : 'De-escalate risk'}>
        <IconButton
          onClick={() => {
            setModalOpen(true);
          }}
        >
          <SyncProblemOutlined color={isEscalated ? 'error' : 'primary'} />
        </IconButton>
      </Tooltip>
      <Modal
        isOpen={modalOpen}
        onToggle={() => {
          setModalOpen(false);
        }}
        title={!isEscalated ? 'Please, provide the escalation reason' : 'Please, provide the de-escalation reason'}
      >
        <ModalForm
          closeModal={() => {
            setModalOpen(false);
          }}
          modalOpen={modalOpen}
          submitFormFunc={values => {
            const payload = {
              riskId,
              reason: values.reason,
            };

            return isEscalated ? deescalateRisk(riskId!, payload) : escalateRisk(riskId!, payload);
          }}
          afterSubmit={{
            message: 'You are awesome! The Risk has been successfully updated.',
            execute: async () => {
              const response = (await onEscalationUpdated?.()) as { data?: ProjectRisksResponse } | undefined;
              const updatedRisk = response?.data?.baseProject?.risks?.find(risk => risk.id === riskId);

              if (updatedRisk) {
                await setData?.(updatedRisk);
              }
            },
          }}
        >
          <TextArea rows={3} source={'reason'} label={isEscalated ? 'De-escalation reason' : 'Escalation reason'} />
        </ModalForm>
      </Modal>
    </>
  );
};
export default EscalationButton;
